import { createI18n } from 'vue-i18n'
import es from './locales/es.json'
import en from './locales/en.json'
import fr from './locales/fr.json'
import de from './locales/de.json'

// Detectar idioma del navegador
const browserLang = navigator.language || navigator.userLanguage;
const browserLangCode = browserLang.split('-')[0];

// Mapeo de códigos de idioma
const languageMap = {
  'es': 'es',
  'en': 'en', 
  'fr': 'fr',
  'de': 'de',
  // Agrega más mapeos según necesites
};

// Idioma por defecto basado en el navegador o español
const defaultLang = languageMap[browserLangCode] || 'es';

// Crear instancia de i18n
const i18n = createI18n({
  locale: defaultLang, // idioma por defecto
  fallbackLocale: 'es', // idioma de respaldo
  messages: {
    es,
    en,
    fr,
    de
  }
})

export default i18n